import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FolderOpen, Inbox, Timer, Activity } from "lucide-react";
import { KpiCard, RecentCasesPanel, StatusBreakdown } from "@/components/portal/DashboardWidgets";

export default function Dashboard() {
  const [d, setD] = useState(null);
  useEffect(() => {
    let cancelled = false;
    api.get("/dashboard")
      .then((r) => { if (!cancelled) setD(r.data); })
      .catch(() => { /* dashboard reloads on next mount */ });
    return () => { cancelled = true; };
  }, []);
  if (!d) return <div className="text-slate-500">Loading…</div>;
  const cards = [
    { label: "Total Cases", val: d.total_cases, icon: FolderOpen, tone: "navy" },
    { label: "New Intakes", val: d.new_intakes, icon: Inbox, tone: "crimson" },
    { label: "Open Tasks", val: d.open_tasks, icon: Timer, tone: "gold" },
    { label: "Active", val: d.by_status?.active || 0, icon: Activity, tone: "green" },
  ];
  return (
    <div className="fade-in-up">
      <div className="mb-8">
        <div className="text-caption text-[#B91C1C] mb-2">CASE COMMAND CENTER</div>
        <h1 className="font-serif text-3xl font-bold text-[#0A192F]">Dashboard</h1>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
        {cards.map((c, i) => <KpiCard key={c.label} icon={c.icon} label={c.label} val={c.val} i={i} />)}
      </div>
      <div className="grid lg:grid-cols-3 gap-6">
        <RecentCasesPanel cases={d.recent_cases || []} />
        <StatusBreakdown byStatus={d.by_status || {}} total={d.total_cases} />
      </div>
    </div>
  );
}
